import React from 'react';
import { Menu, Icon } from 'semantic-ui-react';
import base, { firebase } from '../rebase';
import { FILETYPE_CURRENTSTATUS, FIREBASEREF_UPLOADS, FIREBASEREF_NEWUPLOADS } from '../globals';
import DownloadFromRef from './DownloadFromRef';

export default class DownloadCurrentStatus extends React.Component {
  state = { loading: false };

  onData = (data) => {
    if (data.status !== "done") return;
    if (!data.result) return;

    console.log("Done processing current status");
    DownloadFromRef(data.result, "Transavia PQ - Current status.csv", () => this.setState({loading: false}));
  }

  onClick = () => {
    if (this.state.loading) return;

    this.setState({ loading: true });
    // First upload file, then metadata
    const { key } = firebase.database().ref(FIREBASEREF_UPLOADS).push();
    base.update(FIREBASEREF_UPLOADS + "/" + key, {
      data: {
        uid: this.props.authUser.uid,
        user_display_name: this.props.authUser.display_name,
        timestamp: base.timestamp,
        tour_operator: this.props.authUser.tour_operator,
        status: "new",
        type: FILETYPE_CURRENTSTATUS
      },
      then: function(error) {
        base.update(FIREBASEREF_NEWUPLOADS, {
          data: { [key]: true }
        });
      }
    });

    if (this.binding) base.removeBinding(this.binding);
    this.binding = base.listenTo(FIREBASEREF_UPLOADS + "/" + key, {
      context: this,
      asArray: false,
      then: this.onData
    })
  }

  render() {
    return (
      <Menu.Item onClick={this.onClick}>
        {this.state.loading ? <Icon name="circle notched" loading /> : <Icon name="download" />}
        Current status
      </Menu.Item>
    )
  }
}


// WEBPACK FOOTER //
// ./src/common/DownloadCurrentStatus.js